export default "__VITE_ASSET__0dd41087__"